import "./InputRadio.scss";
import PropTypes from "prop-types";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { useState } from "react";
import colors from "assets/styles/mixins/colors.scss";


const InputRadioGroup = ({
  label,
  isInline,
  isBordered,
  options,
  id,
  getSelectedValue,
  value,
  errors,
  readOnly,
  selectionColor,
}) => {
  const parsedOptions = typeof options === 'string' ? JSON.parse(options) : options;
  const [selectedValue, setSelectedValue] = useState(
    value || _.chain(parsedOptions).head().get("val").value()
  );
  const getColorByval = (rval, original) => {
    const currentValue = value || _.chain(parsedOptions).head().get("val").value();
    if (currentValue === rval) {
      if (original === false) {
        return colors.redLight;
      }
      if (original === true) {
        return colors.lightGreen2;
      }
    }
    switch(rval) {
      case "1":
        return colors.lightGreen2; 
      case "2":
        return colors.lightYellow; 
      case "3":
        return colors.lightRed; 
      default:
        return undefined; 
    }
  };
  const handleChange = (val) => {
    if (!readOnly) {
      setSelectedValue(val.target.value);
      getSelectedValue(val);
    }
  };
  return (
    <div className="input-radio ">
      {label && (
        <div
          className={
            errors?.ref ? "input-radio-label-error" : "input-radio-label"
          }
        >
          {typeof label === "string" ? label : <FormattedMessage {...label} />}
        </div>
      )}

      <div className={isInline ? "inline-radio" : "column-radio"}>
        {parsedOptions?.map((option) => (
          <p
            style={
              selectedValue === option.val
                ? {
                    backgroundColor:  selectionColor || getColorByval(option.val, option.original) ,
                    fontWeight: "bold"
                  }
                : isBordered
                ? { border: "1px solid #c2bfd1" }
                : {}
            }
            key={option?.val}
          >
            <input
              type="radio"
              id={`${id}-${option?.val}`}
              value={option.val}
              name={id}
              onChange={handleChange}
              checked={selectedValue === option.val}
            />
            <label
              for={`${id}-${option?.val}`}
              style={{ cursor: readOnly ? "unset" : "pointer" }}
            >
              {option?.clb || option?.lb}
            </label>
          </p>
        ))}
      </div>
    </div>
  );
};
InputRadioGroup.propTypes = {
  label: PropTypes.any,
  isInline: PropTypes.bool,
  options: PropTypes.array,
  id: PropTypes.string.isRequired,
  getSelectedValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  isBordered: PropTypes.bool,
};
InputRadioGroup.defaultProps = {
  label: "",
  isInline: true,
  options: [],
  value: null,
  isBordered: false,
};
export default InputRadioGroup;
